import defaultConfig from '@/configs/defaultConfig'
import axiosIns from '@/libs/axios'

export default {
  namespaced: true,

  state: {
    courtsData: {},
    allCourts: [],
    allCourtList: [],
    userCourts: [],
    loading: false,
    error: null
  },

  getters: {
    getAllCourts: (state) => state.allCourts,
    getCourtList: (state) => state.allCourtList,
    getUserCourts: (state) => state.userCourts,
    isCourtsLoading: (state) => state.loading,
    hasError: (state) => !!state.error
  },

  mutations: {
    setLoading(state, val) {
      state.loading = val
    },
    setError(state, error) {
      state.error = error
    },
    setCourtsData(state, payload) {
      state.courtsData = payload
    },
    setUserCourts(state, payload) {
      state.userCourts = payload
    },
    setAllCourts(state, payload) {
      state.allCourts = payload.courtsList
      state.allCourtList = payload.allC
    },
    clearCourts(state) {
      state.courtsData = {}
      state.allCourts = []
      state.allCourtList = []
      state.userCourts = []
      state.error = null
      state.loading = false
    }
  },

  actions: {
    async fetchCourts({ commit }) {
      commit('setLoading', true)
      commit('setError', null)

      try {
        const response = await axiosIns.get(defaultConfig.allCourtEndPoint)
        if (response.data.success) {
          const data = response.data.data
          commit('setCourtsData', data)

          // Transform structure
          const courtsList = []
          let allC = []

          const createCourtSection = (label, courts) =>
            courts && courts.length
              ? {
                  label,
                  options: courts.map((key) => ({
                    value: key._id,
                    text: key.title,
                    cslug: key.cli_slug,
                    type: key.type,
                    uniqueId: key.unique_id
                  }))
                }
              : null

          const sc = createCourtSection('Supreme Court', data.supremeCourts)
          const hc = createCourtSection('High Court', data.highCourts)
          const dc = createCourtSection('District Court', data.districtCourts)
          const tc = createCourtSection('Tribunals Court', data.tribunalsCourts)

          // Push only if not null
          ;[sc, hc, dc, tc].forEach((section) => section && courtsList.push(section))

          allC = [
            ...(data.supremeCourts || []),
            ...(data.highCourts || []),
            ...(data.districtCourts || []),
            ...(data.tribunalsCourts || [])
          ].map((key) => ({
            value: key._id,
            text: key.title,
            cslug: key.cli_slug,
            type: key.type,
            uniqueId: key.unique_id
          }))

          commit('setAllCourts', { courtsList, allC })
        }
      } catch (error) {
        console.error('Error fetching courts', error)
        commit('setError', error)
      } finally {
        commit('setLoading', false)
      }
    },

    async fetchCourtTypes({ commit }, value) {
      try {
        const response = await axiosIns.get(
          defaultConfig.getCaseTypesEndPoint({ id: value })
        )
        if (response.data.success) {
          return response.data['data'][0]
        } else {
          throw new Error('Failed to fetch court types')
        }
      } catch (error) {
        console.error('Error fetching court types', error)
        throw error
      }
    },

    async fetchUserCourts({ commit }) {
      commit('setLoading', true)
      commit('setError', null)
      try {
        const response = await axiosIns.get(defaultConfig.userCourtEndPoint)
        if (response.data.success) {
          commit('setUserCourts', response.data.data)
        }
      } catch (error) {
        console.error('Error fetching user courts', error)
        commit('setError', error)
      } finally {
        commit('setLoading', false)
      }
    },

    clearCourts({ commit }) {
      commit('clearCourts')
    }
  }
}
